export default __webpack_public_path__ + "static/media/Splash Screen.87592911.png";